import { PropsWithChildren } from "react";
import { Links, Meta, Outlet, Scripts } from "react-router";

import { AppProviders } from "@providers/AppProviders";

import "./index.css";

export function Layout({ children }: PropsWithChildren) {
  return (
    <html lang="en" className="bg-bg-default h-full">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {/* Must stay the first script: pins window.scrollX/scrollY before third-party scripts run (PROA-2811) */}
        <script src="/scroll-global-guard.js" />
        <title>Frontera Portal</title>
        <link rel="icon" type="image/svg+xml" href="/icon-light.png" media="(prefers-color-scheme: light)" />
        <link rel="icon" type="image/svg+xml" href="/icon-dark.png" media="(prefers-color-scheme: dark)" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;600;700&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
        <link href="/fonts.css" rel="stylesheet" />
        <script src="/pendo.js" />
        <Meta />
        <Links />
      </head>
      <body className="h-full">
        <div className="h-max" id="root">
          {children}
        </div>
        <Scripts />
        <script type="module" src="https://js.navattic.com/embeds.js" />
        <script src="/freshworks.js" />
      </body>
    </html>
  );
}

export default function Root() {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}

export function HydrateFallback() {
  return null;
}

export { RouteErrorElement as ErrorBoundary } from "@components/Error/RouteErrorElement";
